module.exports = __webpack_public_path__ + "static/media/physio1_slide_blur_small.eb9a8115.jpg";